import makeNoopPlugin from "/home/runner/work/babel/babel/packages/babel-standalone/src/make-noop-plugin.ts"; export default makeNoopPlugin()